<template>
  <div class="add-payment-method modal-container">
    <div class="modal-wrapper">
      <div class="modal-content">
        <h3>Add payment method</h3>
        <div class="card-form">
          <label>Card Holder Name</label>
          <input 
            id="card-holder-name" 
            v-model="name" 
            type="text" 
            class="form-control mb-2" 
            required>

          <label>Card</label>
          <div id="card-element"/>

          <button 
            id="add-card-button" 
            class="btn btn-primary mt-3" 
            @click.prevent="submitPaymentMethod">
            Save Payment Method
          </button>
        </div>
        <span 
          class="close-modal" 
          @click.prevent="showModal(false)">+</span>
      </div>
    </div>
  </div>
</template>
<script>

import axios from "axios";
import {mapGetters, mapActions} from "vuex";
import profileMixin from "@/mixins/profileMixin";

export default {
    mixins: [profileMixin],

    data: () => ({
        formData: {},
        stripeAPIToken: process.env.STRIPE_API_TOKEN,
        stripe: null,
        name: ''
    }),

    computed: {
        ...mapGetters(['intentToken']),
    },

    created() {
        this.includeStripe('js.stripe.com/v3/', function () {
            this.configureStripe();
        }.bind(this));

        this.loadIntent();
    },

    methods: {
        ...mapActions(['loadIntentToken', 'savePaymentMethod', 'loadPaymentMethods']),

        includeStripe(URL, callback) {
            var documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) {
                object.addEventListener('load', function (e) {
                    callback(null, e);
                }, false);
            }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        configureStripe() {
            this.stripe = Stripe(this.stripeAPIToken);

            this.elements = this.stripe.elements();
            this.card = this.elements.create('card', {
                style: {
                    base: {
                        iconColor: '#603975',
                        color: '#000',
                        fontWeight: 500,
                        fontSize: '22px',
                        fontSmoothing: 'antialiased',
                        ':-webkit-autofill': {
                            color: '#603975',
                        },
                        '::placeholder': {
                            color: '#603975',
                        },
                    },
                    invalid: {
                        iconColor: '#FFC7EE',
                        color: '#FFC7EE',
                    },
                },
            });

            this.card.mount('#card-element');
        },

        loadIntent() {
            this.loadIntentToken();
        },

        submitPaymentMethod() {
            this.addPaymentStatus = 1;

            this.stripe.confirmCardSetup(
                this.intentToken.client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: {
                            name: this.name
                        }
                    }
                }
            ).then(function (result) {
                if (result.error) {
                    this.addPaymentStatus = 3;
                    this.addPaymentStatusError = result.error.message;
                } else {
                    this.save(result.setupIntent.payment_method);
                    this.addPaymentStatus = 2;
                    this.card.clear();
                    this.name = '';
                }
            }.bind(this));
        },

        save(method) {
            this.formData['payment_method'] = method;
            this.showModal(false);
            this.savePaymentMethod(this.formData).then(() => {
                this.loadPaymentMethods();
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/AddPaymentMethod/AddPaymentMethod.vue